import PAYMENT_LIST from "../graphql/paymentList.gql";
import { apolloClient } from "./apollo";
import NOTIFICATIONS from "../graphql/reportNotifications.gql";
export function getNotifications(userId){
    if (!window.navigator.onLine)
        return '';
    return apolloClient.mutate({
        mutation: NOTIFICATIONS,
        variables: {
            userId: userId
        }
    })
}
export function getPaymentList() {
    return apolloClient.mutate({
        mutation: PAYMENT_LIST
    })
}
